import moment from 'moment';

const DATE_FORMAT = 'YYYY-MM-DD';

export const cohortMonthStart = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const month = moment(value);
  if (!month.isValid()) {
    return null;
  }
  return month.clone().startOf('month').format(DATE_FORMAT);
};

export const cohortMonthEnd = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const month = moment(value);
  if (!month.isValid()) {
    return null;
  }
  return month.clone().endOf('month').format(DATE_FORMAT);
};

export const isFullCalendarMonth = (start, end) => {
  const expectedStart = cohortMonthStart(start);
  const expectedEnd = cohortMonthEnd(start);
  if (!expectedStart || !expectedEnd) {
    return false;
  }
  const actualEnd = moment(end);
  if (!actualEnd.isValid()) {
    return false;
  }
  return (
    expectedStart === moment(start).format(DATE_FORMAT) &&
    expectedEnd === actualEnd.format(DATE_FORMAT)
  );
};

export const formatCohortDateRange = (start, end) => {
  if (!start || !end) {
    return null;
  }
  if (isFullCalendarMonth(start, end)) {
    return moment(start).format('MMM YY');
  }
  return `${moment(start).format('MM/DD/YY')} - ${moment(end).format('MM/DD/YY')}`;
};
